function PlanGroupRegionCell(props) {
    return <>{props.value?.label ?? "-"}</>;
}

export default PlanGroupRegionCell;
